import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 8px",
    position: "fixed",
    top: 0,
    background: theme.colors.background1,
    width: "100%",
    boxSizing: "border-box",
    zIndex: theme.zIndex.appBar,
  },
  left: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  right: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  rank: {
    display: "flex",
    padding: "8px 12px",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
    borderRadius: 100,
    border: "1.5px solid rgba(255, 255, 255, 0.20)",
    color: "#fff",
    fontSize: 16,
    fontWeight: 600,
  },
}));
